(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["furmily-advertorial-10-10"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-fs-sticky]').forEach((sticky)=>{const root=sticky.closest('.fs');const close=root?root.querySelector('[data-fs-close]'):null;if(!close)return;let ticking=false;const update=()=>{const rect=close.getBoundingClientRect();sticky.classList.toggle('is-visible',rect.top<=window.innerHeight*.72);ticking=false};const onScroll=()=>{if(ticking)return;ticking=true;requestAnimationFrame(update)};update();window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furmily-advertorial-video-native"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-fs-sticky]').forEach((sticky)=>{const root=sticky.closest('.fs');const close=root?root.querySelector('[data-fs-close]'):null;if(!close)return;let ticking=false;const update=()=>{const rect=close.getBoundingClientRect();sticky.classList.toggle('is-visible',rect.top<=window.innerHeight*.72);ticking=false};const onScroll=()=>{if(ticking)return;ticking=true;requestAnimationFrame(update)};update();window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll)});
document.querySelectorAll('.fs__media-video,.fs__gallery-video').forEach(v=>{v.muted=true;v.loop=true;v.playsInline=true;v.preload='none'});if('IntersectionObserver'in window){const io=new IntersectionObserver(entries=>entries.forEach(e=>{const v=e.target;e.isIntersecting?v.play().catch(()=>{}):v.pause()}),{rootMargin:'700px 0px'});document.querySelectorAll('.fs__media-video,.fs__gallery-video').forEach(v=>io.observe(v))}else{document.querySelectorAll('.fs__media-video,.fs__gallery-video').forEach(v=>v.play().catch(()=>{}))}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furmily-advertorial"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fa-sticky]').forEach((sticky) => {
    const root = sticky.closest('.fa');
    const trigger = root ? root.querySelector('[id^="fa-midpoint-"]') : null;
    if (!trigger) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => sticky.classList.toggle('is-visible', !entry.isIntersecting));
    }, { threshold: 0 });
    observer.observe(trigger);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furmily-product-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('furmily-product')) {
    customElements.define('furmily-product', class extends HTMLElement {
      connectedCallback() {
        this.buybox = this.querySelector('.fm-buybox');
        this.form = this.querySelector('form[data-type="add-to-cart-form"]');
        this.variantInput = this.querySelector('.product-variant-id');
        this.currentPrice = this.querySelector('[data-current-price]');
        this.comparePrice = this.querySelector('[data-compare-price]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.sticky = this.querySelector('.fm-sticky-buy');
        this.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => this.selectImage(button.dataset.galleryThumb)));
        this.querySelectorAll('.fm-variant input').forEach((input) => input.addEventListener('change', () => this.selectVariant(input)));
        this.querySelectorAll('[data-scroll-buy]').forEach((link) => link.addEventListener('click', (event) => {
          event.preventDefault();
          this.buybox?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }));
        this.querySelector('[data-sticky-add]')?.addEventListener('click', () => this.form?.querySelector('button[type="submit"]')?.click());
        this.setupSticky();
        this.setupTimeline();
      }
      selectImage(index) {
        this.querySelectorAll('[data-media-index]').forEach((media) => media.classList.toggle('is-active', media.dataset.mediaIndex === index));
        this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.galleryThumb === index));
      }
      selectVariant(input) {
        this.querySelectorAll('.fm-variant').forEach((card) => card.classList.remove('is-selected'));
        input.closest('.fm-variant')?.classList.add('is-selected');
        if (this.variantInput) this.variantInput.value = input.value;
        if (this.currentPrice) this.currentPrice.textContent = input.dataset.price;
        if (this.stickyPrice) this.stickyPrice.textContent = input.dataset.price;
        if (this.comparePrice) {
          this.comparePrice.textContent = input.dataset.comparePrice;
          this.comparePrice.hidden = !input.dataset.comparePrice;
        }
        const available = input.dataset.available === 'true';
        this.querySelectorAll('.product-form__submit,[data-sticky-add]').forEach((button) => {
          button.disabled = !available;
          const text = button.querySelector('[data-cta-text]');
          if (text) text.textContent = available ? 'Keep Them Better Hydrated →' : 'Sold Out';
        });
      }
      setupSticky() {
        if (!this.buybox || !this.sticky) return;
        const observer = new IntersectionObserver(([entry]) => this.sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.08 });
        observer.observe(this.buybox);
      }
      setupTimeline() {
        const timeline = this.querySelector('[data-timeline]');
        const weeks = [...this.querySelectorAll('[data-week]')];
        const progress = this.querySelector('[data-progress]');
        if (!timeline || !weeks.length || !progress) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = weeks.indexOf(entry.target);
            weeks.forEach((week, weekIndex) => week.classList.toggle('is-active', weekIndex <= index));
            progress.style.height = `${((index + 1) / weeks.length) * 100}%`;
          });
        }, { rootMargin: '-25% 0px -45% 0px', threshold: 0.1 });
        weeks.forEach((week) => observer.observe(week));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
